import React from 'react';
import Portal from '@src/components/ui2/Portal';
import { useAppSelector } from '@src/core/hooks';
import { MALGA_CHALLENGE_CONTAINER_ID } from '@src/features/payments/external-auth/providers/malga/constants';
import { externalAuthenticationSelector } from '@src/features/payments/store/payment';
import { Challenge3dsContent } from '../PagarmeChallenge3dsModal/style';
import { MalgaChallenge3dsModalBackdrop } from './style';

/**
 * Shows only while a transaction waits on the challenge: the setup is Malga's too, but its device data
 * collection runs in a hidden frame of its own. Unlike Pagar.me's, nothing injects a frame here later, so
 * it shows right away; the provider posts the issuer's screen into the container. It renders in the body,
 * so no checkout layout around it can put the payment spinner on top.
 */
const MalgaChallenge3dsModal = () => {
  const externalAuthentication = useAppSelector(externalAuthenticationSelector);

  if (!externalAuthentication?.data?.['stepUrl']) {
    return null;
  }

  return (
    <Portal>
      <MalgaChallenge3dsModalBackdrop>
        <Challenge3dsContent id={MALGA_CHALLENGE_CONTAINER_ID} />
      </MalgaChallenge3dsModalBackdrop>
    </Portal>
  );
};

export default MalgaChallenge3dsModal;
